module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/info-o-0f79f65d32bcb4fc17bbd0051061eed3.svg";